import { html, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs';
import { comsStore } from '@src/state/ComsStore';
import { FeatureValueStore } from '@src/state/FeatureValueStore';

function stripHtml(htmlString: string) {
  const tmp = document.createElement('div');
  tmp.innerHTML = htmlString;
  return tmp.textContent || tmp.innerText || '';
}

function featureLabel(this: TefComs4csMicroFrontend, feat: FeatureValueStore) {
  return feat.description === feat.title
    ? unsafeHTML(feat.title)
    : this.getTemplateFn('tooltipTemplate')(
      comsStore.config?.styleContext as string,
      feat.description,
      stripHtml(feat.title),
    );
}

export function featureTemplate(
  this: TefComs4csMicroFrontend,
  feature: FeatureValueStore,
  deprecated: boolean,
): TemplateResult {
  return html`
    <one-cluster gap="sm" no-wrap>
      <tef-coms-tri-state-button
        data-testid="${feature.id}"
        .consent=${feature}
        .deprecated=${deprecated}
        .checked=${feature.granted}>
      </tef-coms-tri-state-button>
      <one-content>${/* eslint-disable-line */ featureLabel.bind(this)(feature)}</one-content>
    </one-cluster>
  `;
}
